import { AnswerType, ValueErrorType } from "modules/NewClientSurvey/common/constants"
import { SurveyAnswer, SurveyQuestion } from "modules/NewClientSurvey/common/interface"

export function checkValue(question: SurveyQuestion, inputValue: SurveyAnswer) {
    if (question.required && !inputValue.value) {
        return ValueErrorType.Empty
    }

    if (question.required && question.type === AnswerType.choices) {
        const isSelected = Object.values(inputValue.value).some(Boolean)
        if (!isSelected) return ValueErrorType.Empty
    }

    if (question.required && question.type === AnswerType.choices) {
        const choicesError = checkChoicesLength(
            inputValue,
            question.validations.min_count,
            question.validations.max_count
        )
        if (choicesError) return choicesError
    }

    if (question.type === AnswerType.number) {
        const rangeError = checkValueRange(
            inputValue,
            question.validations.min_value,
            question.validations.max_value
        )
        if (rangeError) return rangeError
    }

    const lengthError = checkValueLength(
        inputValue,
        question.validations.min_length,
        question.validations.max_length
    )
    if (lengthError) return lengthError
    return ValueErrorType.None
}

function checkValueRange(input: SurveyAnswer, min: number | undefined, max: number | undefined) {
    if (min !== undefined && Number(input.value) < min) return ValueErrorType.LessThanRequired
    if (max != undefined && Number(input.value) > max) return ValueErrorType.MoreThanRequired
}

function checkValueLength(input: SurveyAnswer, min: number | undefined, max: number | undefined) {
    if (input && min !== undefined && String(input.value).length < min) {
        return ValueErrorType.ShorterThanRequired
    }
    if (input && max !== undefined && String(input.value).length > max) {
        return ValueErrorType.LongerThanRequired
    }
}

function checkChoicesLength(
    choices: SurveyAnswer,
    min: number | undefined,
    max: number | undefined
) {
    const actualChoices = Object.entries(choices.value).filter(([_, value]) => value)
    if (min !== undefined && actualChoices.length < min) {
        return ValueErrorType.FewerThanRequired
    }

    if (max !== undefined && actualChoices.length > max) {
        return ValueErrorType.ExceedsAllowedCount
    }
}
